import { FC } from 'react';
import cn from 'classnames';
import dayjs from 'dayjs';

import { IBroadcastSettingsProps } from 'hooks/utils/useBroadcastsStatus';

import { isMoreOrLessThanCurrent } from 'utils/dates';

import css from './BroadcastStatus.module.scss';

export interface IBroadcastStatusIcon {
  isNow: boolean;
}
export interface IBroadcastStatusMarkProps {
  settings: IBroadcastSettingsProps;
  dateStart?: string;
  withTime?: boolean;
  label?: string;
  withoutLabel?: boolean;
  withoutPadding?: boolean;
  withoutBackground?: boolean;
  labelColor?: 'white' | 'black';
  align?: 'left' | 'center' | 'right';
}

export const BroadcastStatusIcon: FC<IBroadcastStatusIcon> = ({ isNow }) => {
  return <div className={cn(css.icon, isNow && css.iconNow)} />;
};

export default function BroadcastStatusMark({
  withTime,
  settings,
  dateStart,
  label = 'В эфире',
  withoutBackground,
  withoutLabel,
  withoutPadding,
  align,
  labelColor = 'white',
}: IBroadcastStatusMarkProps) {
  const getFutureBroadcastText = () =>
    withTime && settings?.futureBroadcast
      ? `Трансляция начнется ${dayjs(
          settings?.futureBroadcast.startTime
        ).fromNow()}`
      : 'Трансляция';

  //отображаем плашку со статусом трансляции,
  //только если она еще не началась или уже идет

  return settings.currentBroadcast ||
    settings.futureBroadcast ||
    (dateStart && isMoreOrLessThanCurrent(dateStart, true)) ? (
    <div
      className={cn(
        css.block,
        withoutBackground && css.withoutBackground,
        withoutPadding && css.withoutPadding,
        withoutLabel && align && css[align]
      )}
    >
      <BroadcastStatusIcon isNow={!!settings?.currentBroadcast} />
      {!withoutLabel && (
        <span className={cn(css.text, css[labelColor])}>
          {settings?.currentBroadcast ? label : getFutureBroadcastText()}
        </span>
      )}
    </div>
  ) : null;
}
